import { takeLatest, call, put } from 'redux-saga/effects';
import QUESTION_TYPES from './types';
import notificationActions from '../Notifications/actions';
import sectionActions from '../Sections/actions';
import { sagaWrapper } from 'src/helpers';
import Service from 'src/service';

const Question = new Service('questions');

function* create({ payload }: any) {
	const question = payload.question;
	yield call(Question.create, question);
	// yield put(notificationActions.add('success', 'Pregunta creada'));
	yield put(sectionActions.getOne(question.sectionId));
}

function* update({ payload }: any) {
	const question = payload.question;
	yield call(Question.update, question);
	yield put(notificationActions.add('success', 'Pregunta actualizada'));
	yield put(sectionActions.getOne(question.sectionId));
}

export default function* index() {
	yield takeLatest(QUESTION_TYPES.CREATE, sagaWrapper(create));
	yield takeLatest(QUESTION_TYPES.UPDATE, sagaWrapper(update));
}
